import { sanitize } from 'dompurify';
import useTermsAndConditions from '../../../../../../hooks/queryHooks/useTermsAndConditions';

function InvoiceTerms() {
  const terms = useTermsAndConditions({ type: 'invoice-terms' });
  const sanitizedContent = sanitize(terms?.content);

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
    </div>
  );
}

export default InvoiceTerms;
